<template>
  <div
    v-if="visible"
    class="iframe-modal"
    role="dialog"
    aria-modal="true"
    aria-label="页面详情"
    @click.self="$emit('close')"
  >
    <div class="iframe-modal__content">
      <iframe
        class="iframe-modal__frame"
        :src="`${url}&dfrom=feature`"
        title="页面详情"
        allowfullscreen
      ></iframe>
    </div>
    <button
      class="iframe-modal__close"
      type="button"
      aria-label="关闭"
      title="关闭"
      @click="$emit('close')"
    >
      <img src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAACXBIWXMAABYlAAAWJQFJUiTwAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAFiSURBVHgB7ZY9UsMwEIW1ckUVy+EAnnj4KTmKb0ByAuAEkFtAhct0cAxK6JgJmZiSAuwLYCFBPBijdbSbdPFrLMvSvs8raUdC9Oq16wqwD6PR0VkYRtdhqN7KsngWDCXJ4alSw3ul9qEo3h9cY2TH/HMAOJEyuLOBBMNca5GZZqy1RuejAFVVTeu2DUSBaJiv5n9OsbHoEpTlx+NgEL2aLKSrrjSKhrlJ5ZMgmAPoyXL5MiMDcCBc5ovFPOvy6ASgQHDMvQB8ILjm32MFQXF8MJYSbn+NxNg+ueZkABfEn2BEcyuvJWjKsRxscyspGAoC0P97XX0esQRR7Q3XkFedaIuUAdduryo9qd+pFdPKOwPYUeNWTBLAunO+CcRaAN8iw4UItmG+CQQKEMdJCiBnvuZcCPQUmIvIJdW8Vp7Ps9bpuMLGohlQSu0Z62NjfsGpcD+ZCM1fSxMDbrArWa9evb4AeSMN88Dlx+wAAAAASUVORK5CYII=" alt="" class="sr">
    </button>
  </div>
</template>

<script lang="ts">
import Vue from 'vue'

export default Vue.extend({
  name: 'IframeModal',
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    url: {
      type: String,
      default: '',
    },
  },
  mounted() {
    window.addEventListener('keydown', this.handleKeydown)
  },
  beforeDestroy() {
    window.removeEventListener('keydown', this.handleKeydown)
  },
  methods: {
    handleKeydown(event: KeyboardEvent) {
      if (this.visible && event.key === 'Escape') {
        this.$emit('close')
      }
    },
  },
})
</script>

<style lang="less" scoped>
.iframe-modal {
  position: fixed;
  inset: 0;
  z-index: 3000;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.68);
}

.iframe-modal__content {
  width: 80%;
  height: calc(100% - 80px);
  max-width: 560px;
  overflow: hidden;
  background: #fff;
  border-radius: 8px;
  box-shadow: 0 18px 60px rgba(0, 0, 0, 0.28);
  > iframe {
    width: 100%;
    height: 100%;
  }
}

.iframe-modal__frame {
  display: block;
  width: 100%;
  height: 100%;
  border: 0;
  background: #fff;
}

.iframe-modal__close {
  position: absolute;
  display: flex;
  align-items: center;
  justify-content: center;
  top: 40px;
  left: calc(50% + min(281px, calc(50vw - 44px)) + 16px);
  width: 32px;
  height: 32px;
  padding: 0;
  border: 1px solid #ddd;
  border-radius: 50%;
  background: #fff;
  cursor: pointer;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.16);
  > img {
    width: 16px;
    height: 16px;
  }
}

.iframe-modal__close:hover {
  color: #111;
  background: #f5f5f5;
}
@media (max-width: 960px) {
  .iframe-modal__close {
    width: 22px;
    height: 22px;
    > img {
      width: 10px;
      height: 10px;
    }
  }
}
</style>
